import {
	Component, EventEmitter,
	Inject,
	InjectionToken,
	Input,
	OnChanges,
	OnDestroy,
	Output,
	PLATFORM_ID,
	Renderer2
} from '@angular/core';
import {CommonModule, DOCUMENT, isPlatformBrowser} from '@angular/common';
import {BlogDetails} from "../../blog/interface/blog-details";
import {ActivatedRoute, NavigationEnd, Router, RouterLink} from "@angular/router";
import {filter} from "rxjs";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {StoryDetailsV2} from "../interface/story-details";
import {ContentSectionList} from "../../blog/interface/content-section-list";

@UntilDestroy()
@Component({
  selector: 'fb-story-details-toc',
  standalone: true,
	imports: [CommonModule, RouterLink],
  templateUrl: './story-details-toc.component.html',
  styleUrls: ['./story-details-toc.component.scss']
})
export class StoryDetailsTocComponent implements OnChanges, OnDestroy {

	@Input()
	public storyDetails: StoryDetailsV2 = {} as StoryDetailsV2;
	private fragment: string = '';
	public service: string = 'stories';
	public onScroll: Function = {} as Function;

	@Output()
	public showFaqCollapsed: EventEmitter<boolean> = new EventEmitter<boolean>(false);

	constructor(
		@Inject(PLATFORM_ID) private platformID: InjectionToken<Object>,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private renderer: Renderer2,
		@Inject(DOCUMENT) private _document: Document,
	) {
	}

	ngOnChanges() {
		if(this.storyDetails) {
			this.prepareAnchors(this._router.url.split('/')[3]);
		}
		this._router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.pipe(untilDestroyed(this))
			.subscribe(event => {
				if (event instanceof NavigationEnd) {
					if(this.storyDetails)
						this.prepareAnchors(event.url.split('/')[3])
				}
			});
	}

	public prepareAnchors(service: string) {
		this.fragment = service.split('#')[1];
		// console.log(this.fragment, service);
		if(this.fragment === 'faq-header') {
			this.showFaqCollapsed.emit(false);
		}
		else {
			this.showFaqCollapsed.emit(true);
		}
		this.onSelect(this.fragment);
		this.prepareUI();
	}

	public prepareUI(): void {

		if (!isPlatformBrowser(this.platformID)) return;

		const screenMiddle: number = (window.screen.height * 0.33) ;

		this.onScroll = this.renderer.listen('document', 'scroll', e => {
			this.storyDetails.storyContentSectionList.forEach((feature, index) => {
				let element: HTMLElement = this._document.getElementById(this.getURLId(feature, index))!;
				if( window.scrollY > ((element.offsetTop - 15) + (0.02 * element.offsetHeight))) {
					this.deselectAll();
					feature.selected = true;
				}
			});
			if(this.storyDetails.faq) {
				let element: HTMLElement = this._document.getElementById('faq-header')!;
				if (window.scrollY > ((element.offsetTop - 20) + (0.02 * element.offsetHeight))) {
					this.deselectAll();
					this.storyDetails.faq.selected = true;
				}
			}

			let productElement: HTMLElement = this._document.getElementById('story-products')!;
			if(!productElement)
				return;
			if (window.scrollY > ((productElement.offsetTop - 20) + (0.02 * productElement.offsetHeight))) {
				this.deselectAll();
				this.storyDetails.productSelected = true;
			}
		});

	}

	public onSelect(id: string): void {
		if(id === 'faq-header' && this.storyDetails.faq) {
			this.storyDetails.faq.selected = true;
			setTimeout(() => {
				this._router.navigate(
					[],
					{
						relativeTo: this._activatedRoute,
						fragment: id,
					}
				).then(() => {
				});
			}, 0);
		}
		else if(id === 'story-products') {
			this.storyDetails.productSelected = true;
			setTimeout(() => {
				this._router.navigate(
					[],
					{
						relativeTo: this._activatedRoute,
						fragment: id,
					}
				).then(() => {
				});
			}, 0);
		}
		else {
			this.storyDetails.storyContentSectionList.forEach((feature, index) => {
				feature.selected = this.getURLId(feature, index) === id;
				if(feature.selected) {
					setTimeout(() => {
						this._router.navigate(
							[],
							{
								relativeTo: this._activatedRoute,
								fragment: id,
							}
						).then(() => {
						});
					}, 0);

				}
			});
		}

	}

	public getURLId(option: ContentSectionList, index: number): string {
		let title: string = '';
		if(option.heading) {
			title = option.heading;
		}
		else if(option.title1) {
			title = option.title1;
		}
		else if(option.title2) {
			title = option.title2;
		}
		else if(option.templateType === 9 || option.templateType === 10) {
			title = option.image1Alt
		}
		return title? title.toLowerCase().replace(/\s+/g, '-') + '-' + (index + 1): 'section-' + (index + 1).toString();
	}

	public getURLHeading(option: ContentSectionList, index: number): string {
		let title: string = '';
		if(option.heading) {
			title = option.heading;
		}
		else if(option.title1) {
			title = option.title1;
		}
		else if(option.title2) {
			title = option.title2;
		}
		else if(option.templateType === 9 || option.templateType === 10) {
			title = option.image1Alt
		}
		return title? title.toLowerCase(): 'Section ' + (index + 1).toString();
	}

	public deselectAll(): void {
		this.storyDetails.storyContentSectionList.forEach(feature =>  feature.selected = false);
		if(this.storyDetails.faq) {
			this.storyDetails.faq.selected = false;
		}
		this.storyDetails.productSelected = false;
	}

	ngOnDestroy() {
		if (isPlatformBrowser(this.platformID)) {
			this.onScroll();
		}
	}

}
